// GalleryItem.jsx
import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

const GalleryItem = ({ image, index, openModal }) => {
  // Create a ref for each image item
  const ref = useRef(null);

  // Set up scroll animation
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["0 1", "1.5 1"],
  });

  // Transform scrollYProgress to scale and opacity values
  const scaleProgress = useTransform(scrollYProgress, [0, 1], [0.8, 1]);
  const opacityProgress = useTransform(scrollYProgress, [0, 1], [0.3, 1]);
  const rotateProgress = useTransform(
    scrollYProgress,
    [0, 1],
    [index % 2 === 0 ? -5 : 5, 0]
  );

  return (
    <motion.div
      ref={ref}
      className="masonry-item"
      onClick={() => openModal(image)}
      style={{
        scale: scaleProgress,
        opacity: opacityProgress,
        rotate: rotateProgress,
      }}
      initial={{
        opacity: 0,
        scale: 0.8,
        rotate: index % 2 === 0 ? -5 : 5,
      }}
    >
      <img
        src={image.src}
        alt={image.alt || `Gallery image ${index + 1}`}
        loading="lazy"
      />
    </motion.div>
  );
};

export default GalleryItem;
